"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DYNAMIC_IDS = exports.ADD_FAVORITE_MARKET_FAIL = exports.ADD_FAVORITE_MARKET_SUCCESS = exports.ADD_FAVORITE_MARKET_REQUEST = exports.REMOVE_FAVORITE_MARKET_ACTION = exports.ADD_FAVORITE_MARKET_ACTION = exports.FAVORITE_MARKETS_KEY = exports.NAME = void 0;
// TODO: rename 'favoriteMarkets' to 'favorite-markets' GINFE-1847
exports.NAME = 'favoriteMarkets';
exports.FAVORITE_MARKETS_KEY = 'favoriteMarketsId';
exports.ADD_FAVORITE_MARKET_ACTION = exports.NAME + "/ADD_FAVORITE_MARKET_ACTION";
exports.REMOVE_FAVORITE_MARKET_ACTION = exports.NAME + "/REMOVE_FAVORITE_MARKET_ACTION";
exports.ADD_FAVORITE_MARKET_REQUEST = exports.NAME + "/ADD_FAVORITE_MARKET:REQUEST";
exports.ADD_FAVORITE_MARKET_SUCCESS = exports.NAME + "/ADD_FAVORITE_MARKET:SUCCESS";
exports.ADD_FAVORITE_MARKET_FAIL = exports.NAME + "/ADD_FAVORITE_MARKET:FAIL";
exports.DYNAMIC_IDS = [
    8,
    13,
    25,
    288,
    289,
    293,
    79,
    49,
    106,
    175,
    173,
    27,
    55,
];
//# sourceMappingURL=constants.js.map